export function workflowPreferenceKey(userId: string): string {
  return `bimgo.workflow-beta.${userId}`;
}

export function readWorkflowPreferences(raw: string | null): string[] {
  try {
    const value: unknown = JSON.parse(raw ?? "[]");
    return Array.isArray(value) ? value.filter((id): id is string => typeof id === "string") : [];
  } catch {
    return [];
  }
}
